import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SelectableCampaignTerm } from '../../../../models/selectable-campaign-term';
import { TermBindingModel } from '../../../../models/campaign-save';

@Component({
  selector: 'campaign-term',
  templateUrl: './campaign-term.component.html',
  styleUrls: ['./campaign-term.component.scss']
})
export class CampaignTermComponent implements OnInit {
  @Input()
  campaignTerm: TermBindingModel;
  @Input()
  isReadOnly: boolean;

  @Output()
  selectEvent = new EventEmitter<any>();
  @Output()
  deleteEvent = new EventEmitter<any>();
  @Output()
  editEvent = new EventEmitter<any>();

  get selected() {
    // return this.campaignTerm ? (this.campaignTerm.required || this.campaignTerm.isUsed) : false;
    return this.campaignTerm ? this.campaignTerm.selected : false;
  }

  constructor() { }

  ngOnInit() {
  }

  onSelect(e) {
    if (!this.campaignTerm) {
      return;
    }
    if (!this.isReadOnly) {
      this.campaignTerm.selected = !this.campaignTerm.selected;
      this.selectEvent.emit({
        selected: this.selected,
        campaignTerm: this.selected,
        event: e
      });
    }
  }

  delete(e, termId) {
    e.stopPropagation();
    this.deleteEvent.emit(termId);
  }

  edit(e, term) {
    e.stopPropagation();
    this.editEvent.emit({...term});
  }

}



// WEBPACK FOOTER //
// ./src/app/main/campaigns-add/campaign-term/campaign-term.component.ts